import { render, staticRenderFns } from "./ScrollNoticeBar.vue?vue&type=template&id=7327592a&scoped=true"
import script from "./ScrollNoticeBar.vue?vue&type=script&lang=js"
export * from "./ScrollNoticeBar.vue?vue&type=script&lang=js"
import style0 from "./ScrollNoticeBar.vue?vue&type=style&index=0&id=7327592a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7327592a",
  null
  
)

export default component.exports